/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeListScheduledPaymentDto,
  ApiEnvelopePaymentLedgerEntryDetailDto,
  ApiEnvelopePaymentLedgerPageDto,
  ApiEnvelopePaymentSummaryDto,
  ApiEnvelopeScheduledPaymentDto,
  ApiEnvelopeScheduledPaymentPreviewDto,
  PaymentNoteRequest,
  PaymentResolveRequest,
  PaymentsLedgerParams,
  PaymentsSummaryParams,
  ScheduledPaymentRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type paymentsLedgerResponse200 = {
  data: ApiEnvelopePaymentLedgerPageDto
  status: 200
}

export type paymentsLedgerResponse403 = {
  data: ApiEnvelopePaymentLedgerPageDto
  status: 403
}

export type paymentsLedgerResponse404 = {
  data: ApiEnvelopePaymentLedgerPageDto
  status: 404
}

export type paymentsLedgerResponseSuccess = (paymentsLedgerResponse200) & {
  headers: Headers;
};
export type paymentsLedgerResponseError = (paymentsLedgerResponse403 | paymentsLedgerResponse404) & {
  headers: Headers;
};

export type paymentsLedgerResponse = (paymentsLedgerResponseSuccess | paymentsLedgerResponseError)

export const getPaymentsLedgerUrl = (botId: string,
    params?: PaymentsLedgerParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/bots/${botId}/payments/ledger?${stringifiedParams}` : `/api/bots/${botId}/payments/ledger`
}

export const usePaymentsLedgerHook = (): (botId: string,
    params?: PaymentsLedgerParams, options?: RequestInit) => Promise<paymentsLedgerResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    params?: PaymentsLedgerParams, options?: RequestInit) => {

        return customFetcher(getPaymentsLedgerUrl(botId,params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type paymentsSummaryResponse200 = {
  data: ApiEnvelopePaymentSummaryDto
  status: 200
}

export type paymentsSummaryResponse403 = {
  data: ApiEnvelopePaymentSummaryDto
  status: 403
}

export type paymentsSummaryResponse404 = {
  data: ApiEnvelopePaymentSummaryDto
  status: 404
}

export type paymentsSummaryResponseSuccess = (paymentsSummaryResponse200) & {
  headers: Headers;
};
export type paymentsSummaryResponseError = (paymentsSummaryResponse403 | paymentsSummaryResponse404) & {
  headers: Headers;
};

export type paymentsSummaryResponse = (paymentsSummaryResponseSuccess | paymentsSummaryResponseError)

export const getPaymentsSummaryUrl = (botId: string,
    params?: PaymentsSummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/bots/${botId}/payments/summary?${stringifiedParams}` : `/api/bots/${botId}/payments/summary`
}

export const usePaymentsSummaryHook = (): (botId: string,
    params?: PaymentsSummaryParams, options?: RequestInit) => Promise<paymentsSummaryResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    params?: PaymentsSummaryParams, options?: RequestInit) => {

        return customFetcher(getPaymentsSummaryUrl(botId,params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type paymentsEntryResponse200 = {
  data: ApiEnvelopePaymentLedgerEntryDetailDto
  status: 200
}

export type paymentsEntryResponse403 = {
  data: ApiEnvelopePaymentLedgerEntryDetailDto
  status: 403
}

export type paymentsEntryResponse404 = {
  data: ApiEnvelopePaymentLedgerEntryDetailDto
  status: 404
}

export type paymentsEntryResponseSuccess = (paymentsEntryResponse200) & {
  headers: Headers;
};
export type paymentsEntryResponseError = (paymentsEntryResponse403 | paymentsEntryResponse404) & {
  headers: Headers;
};

export type paymentsEntryResponse = (paymentsEntryResponseSuccess | paymentsEntryResponseError)

export const getPaymentsEntryUrl = (botId: string,
    entryId: string,) => {




  return `/api/bots/${botId}/payments/ledger/${entryId}`
}

export const usePaymentsEntryHook = (): (botId: string,
    entryId: string, options?: RequestInit) => Promise<paymentsEntryResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    entryId: string, options?: RequestInit) => {

        return customFetcher(getPaymentsEntryUrl(botId,entryId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type paymentsSetNoteResponse200 = {
  data: ApiEnvelopePaymentLedgerEntryDetailDto
  status: 200
}

export type paymentsSetNoteResponse400 = {
  data: ApiEnvelopePaymentLedgerEntryDetailDto
  status: 400
}

export type paymentsSetNoteResponse403 = {
  data: ApiEnvelopePaymentLedgerEntryDetailDto
  status: 403
}

export type paymentsSetNoteResponse404 = {
  data: ApiEnvelopePaymentLedgerEntryDetailDto
  status: 404
}

export type paymentsSetNoteResponseSuccess = (paymentsSetNoteResponse200) & {
  headers: Headers;
};
export type paymentsSetNoteResponseError = (paymentsSetNoteResponse400 | paymentsSetNoteResponse403 | paymentsSetNoteResponse404) & {
  headers: Headers;
};

export type paymentsSetNoteResponse = (paymentsSetNoteResponseSuccess | paymentsSetNoteResponseError)

export const getPaymentsSetNoteUrl = (botId: string,
    entryId: string,) => {




  return `/api/bots/${botId}/payments/ledger/${entryId}/note`
}

export const usePaymentsSetNoteHook = (): (botId: string,
    entryId: string,
    paymentNoteRequest?: PaymentNoteRequest, options?: RequestInit) => Promise<paymentsSetNoteResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    entryId: string,
    paymentNoteRequest?: PaymentNoteRequest, options?: RequestInit) => {

        return customFetcher(getPaymentsSetNoteUrl(botId,entryId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(paymentNoteRequest)
  }
);
      }
  }


export type paymentsResolveResponse200 = {
  data: ApiEnvelopePaymentLedgerEntryDetailDto
  status: 200
}

export type paymentsResolveResponse400 = {
  data: ApiEnvelopePaymentLedgerEntryDetailDto
  status: 400
}

export type paymentsResolveResponse403 = {
  data: ApiEnvelopePaymentLedgerEntryDetailDto
  status: 403
}

export type paymentsResolveResponse404 = {
  data: ApiEnvelopePaymentLedgerEntryDetailDto
  status: 404
}

export type paymentsResolveResponseSuccess = (paymentsResolveResponse200) & {
  headers: Headers;
};
export type paymentsResolveResponseError = (paymentsResolveResponse400 | paymentsResolveResponse403 | paymentsResolveResponse404) & {
  headers: Headers;
};

export type paymentsResolveResponse = (paymentsResolveResponseSuccess | paymentsResolveResponseError)

export const getPaymentsResolveUrl = (botId: string,
    entryId: string,) => {




  return `/api/bots/${botId}/payments/ledger/${entryId}/resolve`
}

export const usePaymentsResolveHook = (): (botId: string,
    entryId: string,
    paymentResolveRequest?: PaymentResolveRequest, options?: RequestInit) => Promise<paymentsResolveResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    entryId: string,
    paymentResolveRequest?: PaymentResolveRequest, options?: RequestInit) => {

        return customFetcher(getPaymentsResolveUrl(botId,entryId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(paymentResolveRequest)
  }
);
      }
  }


export type paymentsScheduledResponse200 = {
  data: ApiEnvelopeListScheduledPaymentDto
  status: 200
}

export type paymentsScheduledResponse403 = {
  data: ApiEnvelopeListScheduledPaymentDto
  status: 403
}

export type paymentsScheduledResponse404 = {
  data: ApiEnvelopeListScheduledPaymentDto
  status: 404
}

export type paymentsScheduledResponseSuccess = (paymentsScheduledResponse200) & {
  headers: Headers;
};
export type paymentsScheduledResponseError = (paymentsScheduledResponse403 | paymentsScheduledResponse404) & {
  headers: Headers;
};

export type paymentsScheduledResponse = (paymentsScheduledResponseSuccess | paymentsScheduledResponseError)

export const getPaymentsScheduledUrl = (botId: string,) => {




  return `/api/bots/${botId}/payments/scheduled`
}

export const usePaymentsScheduledHook = (): (botId: string, options?: RequestInit) => Promise<paymentsScheduledResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getPaymentsScheduledUrl(botId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type paymentsCreateScheduledResponse200 = {
  data: ApiEnvelopeScheduledPaymentDto
  status: 200
}

export type paymentsCreateScheduledResponse400 = {
  data: ApiEnvelopeScheduledPaymentDto
  status: 400
}

export type paymentsCreateScheduledResponse403 = {
  data: ApiEnvelopeScheduledPaymentDto
  status: 403
}

export type paymentsCreateScheduledResponse404 = {
  data: ApiEnvelopeScheduledPaymentDto
  status: 404
}

export type paymentsCreateScheduledResponseSuccess = (paymentsCreateScheduledResponse200) & {
  headers: Headers;
};
export type paymentsCreateScheduledResponseError = (paymentsCreateScheduledResponse400 | paymentsCreateScheduledResponse403 | paymentsCreateScheduledResponse404) & {
  headers: Headers;
};

export type paymentsCreateScheduledResponse = (paymentsCreateScheduledResponseSuccess | paymentsCreateScheduledResponseError)

export const getPaymentsCreateScheduledUrl = (botId: string,) => {




  return `/api/bots/${botId}/payments/scheduled`
}

export const usePaymentsCreateScheduledHook = (): (botId: string,
    scheduledPaymentRequest?: ScheduledPaymentRequest, options?: RequestInit) => Promise<paymentsCreateScheduledResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    scheduledPaymentRequest?: ScheduledPaymentRequest, options?: RequestInit) => {

        return customFetcher(getPaymentsCreateScheduledUrl(botId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(scheduledPaymentRequest)
  }
);
      }
  }


export type paymentsPreviewScheduledResponse200 = {
  data: ApiEnvelopeScheduledPaymentPreviewDto
  status: 200
}

export type paymentsPreviewScheduledResponse403 = {
  data: ApiEnvelopeScheduledPaymentPreviewDto
  status: 403
}

export type paymentsPreviewScheduledResponse404 = {
  data: ApiEnvelopeScheduledPaymentPreviewDto
  status: 404
}

export type paymentsPreviewScheduledResponseSuccess = (paymentsPreviewScheduledResponse200) & {
  headers: Headers;
};
export type paymentsPreviewScheduledResponseError = (paymentsPreviewScheduledResponse403 | paymentsPreviewScheduledResponse404) & {
  headers: Headers;
};

export type paymentsPreviewScheduledResponse = (paymentsPreviewScheduledResponseSuccess | paymentsPreviewScheduledResponseError)

export const getPaymentsPreviewScheduledUrl = (botId: string,) => {




  return `/api/bots/${botId}/payments/scheduled/preview`
}

export const usePaymentsPreviewScheduledHook = (): (botId: string,
    scheduledPaymentRequest?: ScheduledPaymentRequest, options?: RequestInit) => Promise<paymentsPreviewScheduledResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    scheduledPaymentRequest?: ScheduledPaymentRequest, options?: RequestInit) => {

        return customFetcher(getPaymentsPreviewScheduledUrl(botId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(scheduledPaymentRequest)
  }
);
      }
  }


export type paymentsUpdateScheduledResponse200 = {
  data: ApiEnvelopeScheduledPaymentDto
  status: 200
}

export type paymentsUpdateScheduledResponse400 = {
  data: ApiEnvelopeScheduledPaymentDto
  status: 400
}

export type paymentsUpdateScheduledResponse403 = {
  data: ApiEnvelopeScheduledPaymentDto
  status: 403
}

export type paymentsUpdateScheduledResponse404 = {
  data: ApiEnvelopeScheduledPaymentDto
  status: 404
}

export type paymentsUpdateScheduledResponseSuccess = (paymentsUpdateScheduledResponse200) & {
  headers: Headers;
};
export type paymentsUpdateScheduledResponseError = (paymentsUpdateScheduledResponse400 | paymentsUpdateScheduledResponse403 | paymentsUpdateScheduledResponse404) & {
  headers: Headers;
};

export type paymentsUpdateScheduledResponse = (paymentsUpdateScheduledResponseSuccess | paymentsUpdateScheduledResponseError)

export const getPaymentsUpdateScheduledUrl = (botId: string,
    scheduledPaymentId: string,) => {




  return `/api/bots/${botId}/payments/scheduled/${scheduledPaymentId}`
}

export const usePaymentsUpdateScheduledHook = (): (botId: string,
    scheduledPaymentId: string,
    scheduledPaymentRequest?: ScheduledPaymentRequest, options?: RequestInit) => Promise<paymentsUpdateScheduledResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    scheduledPaymentId: string,
    scheduledPaymentRequest?: ScheduledPaymentRequest, options?: RequestInit) => {

        return customFetcher(getPaymentsUpdateScheduledUrl(botId,scheduledPaymentId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(scheduledPaymentRequest)
  }
);
      }
  }


export type paymentsCancelScheduledResponse200 = {
  data: ApiEnvelopeScheduledPaymentDto
  status: 200
}

export type paymentsCancelScheduledResponse403 = {
  data: ApiEnvelopeScheduledPaymentDto
  status: 403
}

export type paymentsCancelScheduledResponse404 = {
  data: ApiEnvelopeScheduledPaymentDto
  status: 404
}

export type paymentsCancelScheduledResponseSuccess = (paymentsCancelScheduledResponse200) & {
  headers: Headers;
};
export type paymentsCancelScheduledResponseError = (paymentsCancelScheduledResponse403 | paymentsCancelScheduledResponse404) & {
  headers: Headers;
};

export type paymentsCancelScheduledResponse = (paymentsCancelScheduledResponseSuccess | paymentsCancelScheduledResponseError)

export const getPaymentsCancelScheduledUrl = (botId: string,
    scheduledPaymentId: string,) => {




  return `/api/bots/${botId}/payments/scheduled/${scheduledPaymentId}`
}

export const usePaymentsCancelScheduledHook = (): (botId: string,
    scheduledPaymentId: string, options?: RequestInit) => Promise<paymentsCancelScheduledResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    scheduledPaymentId: string, options?: RequestInit) => {

        return customFetcher(getPaymentsCancelScheduledUrl(botId,scheduledPaymentId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type paymentsPauseScheduledResponse200 = {
  data: ApiEnvelopeScheduledPaymentDto
  status: 200
}

export type paymentsPauseScheduledResponse400 = {
  data: ApiEnvelopeScheduledPaymentDto
  status: 400
}

export type paymentsPauseScheduledResponse403 = {
  data: ApiEnvelopeScheduledPaymentDto
  status: 403
}

export type paymentsPauseScheduledResponse404 = {
  data: ApiEnvelopeScheduledPaymentDto
  status: 404
}

export type paymentsPauseScheduledResponseSuccess = (paymentsPauseScheduledResponse200) & {
  headers: Headers;
};
export type paymentsPauseScheduledResponseError = (paymentsPauseScheduledResponse400 | paymentsPauseScheduledResponse403 | paymentsPauseScheduledResponse404) & {
  headers: Headers;
};

export type paymentsPauseScheduledResponse = (paymentsPauseScheduledResponseSuccess | paymentsPauseScheduledResponseError)

export const getPaymentsPauseScheduledUrl = (botId: string,
    scheduledPaymentId: string,) => {




  return `/api/bots/${botId}/payments/scheduled/${scheduledPaymentId}/pause`
}

export const usePaymentsPauseScheduledHook = (): (botId: string,
    scheduledPaymentId: string, options?: RequestInit) => Promise<paymentsPauseScheduledResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    scheduledPaymentId: string, options?: RequestInit) => {

        return customFetcher(getPaymentsPauseScheduledUrl(botId,scheduledPaymentId),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type paymentsResumeScheduledResponse200 = {
  data: ApiEnvelopeScheduledPaymentDto
  status: 200
}

export type paymentsResumeScheduledResponse400 = {
  data: ApiEnvelopeScheduledPaymentDto
  status: 400
}

export type paymentsResumeScheduledResponse403 = {
  data: ApiEnvelopeScheduledPaymentDto
  status: 403
}

export type paymentsResumeScheduledResponse404 = {
  data: ApiEnvelopeScheduledPaymentDto
  status: 404
}

export type paymentsResumeScheduledResponseSuccess = (paymentsResumeScheduledResponse200) & {
  headers: Headers;
};
export type paymentsResumeScheduledResponseError = (paymentsResumeScheduledResponse400 | paymentsResumeScheduledResponse403 | paymentsResumeScheduledResponse404) & {
  headers: Headers;
};

export type paymentsResumeScheduledResponse = (paymentsResumeScheduledResponseSuccess | paymentsResumeScheduledResponseError)

export const getPaymentsResumeScheduledUrl = (botId: string,
    scheduledPaymentId: string,) => {




  return `/api/bots/${botId}/payments/scheduled/${scheduledPaymentId}/resume`
}

export const usePaymentsResumeScheduledHook = (): (botId: string,
    scheduledPaymentId: string, options?: RequestInit) => Promise<paymentsResumeScheduledResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    scheduledPaymentId: string, options?: RequestInit) => {

        return customFetcher(getPaymentsResumeScheduledUrl(botId,scheduledPaymentId),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type paymentsSkipScheduledResponse200 = {
  data: ApiEnvelopeScheduledPaymentDto
  status: 200
}

export type paymentsSkipScheduledResponse400 = {
  data: ApiEnvelopeScheduledPaymentDto
  status: 400
}

export type paymentsSkipScheduledResponse403 = {
  data: ApiEnvelopeScheduledPaymentDto
  status: 403
}

export type paymentsSkipScheduledResponse404 = {
  data: ApiEnvelopeScheduledPaymentDto
  status: 404
}

export type paymentsSkipScheduledResponseSuccess = (paymentsSkipScheduledResponse200) & {
  headers: Headers;
};
export type paymentsSkipScheduledResponseError = (paymentsSkipScheduledResponse400 | paymentsSkipScheduledResponse403 | paymentsSkipScheduledResponse404) & {
  headers: Headers;
};

export type paymentsSkipScheduledResponse = (paymentsSkipScheduledResponseSuccess | paymentsSkipScheduledResponseError)

export const getPaymentsSkipScheduledUrl = (botId: string,
    scheduledPaymentId: string,) => {




  return `/api/bots/${botId}/payments/scheduled/${scheduledPaymentId}/skip`
}

export const usePaymentsSkipScheduledHook = (): (botId: string,
    scheduledPaymentId: string, options?: RequestInit) => Promise<paymentsSkipScheduledResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    scheduledPaymentId: string, options?: RequestInit) => {

        return customFetcher(getPaymentsSkipScheduledUrl(botId,scheduledPaymentId),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type paymentsPayScheduledNowResponse200 = {
  data: ApiEnvelopeScheduledPaymentDto
  status: 200
}

export type paymentsPayScheduledNowResponse400 = {
  data: ApiEnvelopeScheduledPaymentDto
  status: 400
}

export type paymentsPayScheduledNowResponse403 = {
  data: ApiEnvelopeScheduledPaymentDto
  status: 403
}

export type paymentsPayScheduledNowResponse404 = {
  data: ApiEnvelopeScheduledPaymentDto
  status: 404
}

export type paymentsPayScheduledNowResponseSuccess = (paymentsPayScheduledNowResponse200) & {
  headers: Headers;
};
export type paymentsPayScheduledNowResponseError = (paymentsPayScheduledNowResponse400 | paymentsPayScheduledNowResponse403 | paymentsPayScheduledNowResponse404) & {
  headers: Headers;
};

export type paymentsPayScheduledNowResponse = (paymentsPayScheduledNowResponseSuccess | paymentsPayScheduledNowResponseError)

export const getPaymentsPayScheduledNowUrl = (botId: string,
    scheduledPaymentId: string,) => {




  return `/api/bots/${botId}/payments/scheduled/${scheduledPaymentId}/pay-now`
}

export const usePaymentsPayScheduledNowHook = (): (botId: string,
    scheduledPaymentId: string, options?: RequestInit) => Promise<paymentsPayScheduledNowResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    scheduledPaymentId: string, options?: RequestInit) => {

        return customFetcher(getPaymentsPayScheduledNowUrl(botId,scheduledPaymentId),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


